import { ClientModel, ClientPhone } from '@common/models';

export const normalizePhone = (
  n: string | undefined | null,
  wrapAreaCode?: boolean,
) => {
  if (!n) return '-';
  const newN = n.replace(/\D/g, '');
  if (newN.length === 10) {
    if (wrapAreaCode)
      return `(${newN.substring(0, 3)}) ${newN.substring(3, 6)}-${newN.substring(6, 10)}`;
    else
      return `${newN.substring(0, 3)}-${newN.substring(3, 6)}-${newN.substring(6, 10)}`;
  }
  return n;
};
export const getPrimaryPhoneNumberFromClient = ({
  cellPhone,
  homePhone,
  alternatePhone,
}: Partial<ClientModel>) => {
  const primaryPhone = cellPhone || homePhone || alternatePhone || undefined;
  return primaryPhone;
};
export const formatPhoneNumberForViewLogic = (
  primaryPhone: string | undefined,
) => {
  // example phone: 619-948-0856
  if (primaryPhone) {
    const delimitedPhone = primaryPhone.split('-');
    if (delimitedPhone.length === 3) {
      const [areaCode, exchangeCode, subscriberNumber] = delimitedPhone;
      const finalString = `(${areaCode}) ${exchangeCode}-${subscriberNumber}`;
      return finalString;
    } else {
      return primaryPhone;
    }
  } else {
    return '';
  }
};
export const phoneCallScreener = (
  phoneNumber: string | undefined,
  canCall: boolean | undefined,
) =>
  phoneNumber
    ? canCall === false // Can call does not mask intentionally if undefined.
      ? `***-***-${phoneNumber?.slice(-4)}`
      : phoneNumber
    : '';

export const getFormattedPrimaryPhoneNumber = ({
  cellPhone,
  homePhone,
  alternatePhone,
}: ClientPhone) => {
  const primaryPhone = getPrimaryPhoneNumberFromClient({
    cellPhone,
    homePhone,
    alternatePhone,
  });
  const formattedPrimaryPhone = formatPhoneNumberForViewLogic(primaryPhone);
  return formattedPrimaryPhone;
};
